/**
 * English-only fallback copy for the "Explore other Capabilities and Solutions" section, used by
 * `../BasePage/BasePage.tsx` when a page's `pageContent` has no
 * `exploreOtherCapabilitiesAndSolutions`. All four pages that use `BasePage` set it, so this copy
 * isn't shown today. Its cards have no `linkUrl` and it has no `learnMoreUrl`, so if it were
 * shown, the cards would have no headings (see `./ExploreOtherCapabilitiesSolutions.tsx`).
 */
import { ExploreOtherCapabilitiesSolutionsProps } from "./ExploreOtherCapabilitiesSolutions";

/** The fallback copy; see the file header. */
export const ExploreOtherCapabilitiesSolutionsContent: ExploreOtherCapabilitiesSolutionsProps = {
	title: "Explore other Capabilities and Solutions",
	section: [
		{
			imageUrl: "/LeadershipMobileImage2.jpg",
			mainText: "Fabrication",
			subText: `From precision cutting to punching, bending and welding, we have the capabilities to transform metal into what you need.`,
			badgeText: "Capabilities",
			badgeColor: "other",
		},
		{
			imageUrl: "/LeadershipMobileImage3.jpg",
			mainText: "Advanced Processing",
			subText:
				"We have the ability to produce engineered-to-order parts that meet your exact specifications. Our facilities have diverse capabilities, providing quick service and specialized processing.",
			badgeText: "Solution",
			badgeColor: "error",
		},
	],
	learnMoreText: "Learn more about our Metal Solutions",
};
